import { Zahlweise } from '@ps20/bff-models';
import { App } from '@ps20-frontend/frontend-models';
import { PS20Logger } from '@ps20-frontend/logging';

export function mapGesamtbeitragIfJaehrlichAndBeitragIsWrong(
  zahlweise: Zahlweise,
  gesamtbeitragMitRabatt: number,
  jahresbeitrag: number,
  app: App,
): number {
  if (zahlweise === Zahlweise.JAEHRLICH && gesamtbeitragMitRabatt !== jahresbeitrag) {
    PS20Logger.info(
      `gesamtbeitragMitRabatt=${gesamtbeitragMitRabatt} is different to jahresbeitrag=${jahresbeitrag}`,
      `although zahlweise=${zahlweise}`,
      app,
    );
    return jahresbeitrag;
  }
  return gesamtbeitragMitRabatt;
}

export function convertZahlweiseInMonthInYear(zahlweise: Zahlweise): number {
  switch (zahlweise) {
    case Zahlweise.MONATLICH:
      return 12;
    case Zahlweise.VIERTELJAEHRLICH:
      return 4;
    case Zahlweise.HALBJAEHRLICH:
      return 2;
    case Zahlweise.JAEHRLICH:
      return 1;
    default:
      return 1;
  }
}
